import Component from 'can/component/component';
import _ from 'lodash';
import {
    authorize as auth0Authorize,
    init as auth0Init,
    logout as auth0Logout,
    checkSession as auth0CheckSession,
    getUserInfo,
    availableActions,
} from 'scripts/services/auth0';
import template from './vc-subnavigation.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import appContext from 'scripts/app-context';
import localStorageService from 'scripts/services/localstorage-service';

const promotions = {
    title: 'promotions',
    link: '/victory-club-promotions.html',
};

const notLoggedItems = [
    { title: 'join', action: availableActions.register },
    { title: 'login', action: availableActions.authorize },
    promotions,
];

const profileUrl = window.globalSettings.vc.auth0.profileUrl;
const loggedItems = [{ title: 'my account', link: profileUrl }, promotions];

Component.extend({
    tag: 'vc-subnavigation',
    template: template,
    viewModel: {
        define: {
            logo: {
                type: 'object',
                value: {
                    identifier: 'us-open/Victory-Club/VC_Logo',
                },
            },
            navigationItems: {
                type: 'array',
                value: [],
            },
            auth0error: {
                type: 'boolean',
                value: window.location.hash.includes('auth0error'),
            },
            errorMessage: {
                type: 'boolean',
                value: window.location.hash.includes('error-message'),
            },
        },
        itemClicked(item) {
            const itemData = item.serialize();

            if (itemData.action === availableActions.authorize) {
                auth0Authorize('login');
            }
            if (itemData.action === availableActions.register) {
                auth0Authorize('signUp');
            }
            if (itemData.action === availableActions.logout) {
                auth0Logout();
            }
            if (itemData.link) {
                window.location.href = itemData.link;
            }
        },
        closePopup() {
            this.attr('popup').css({ visibility: 'hidden' });
            window.location.hash = '';
        },
    },
    events: {
        async inserted() {
            DomEventsManager.subscribe(this);
            this.viewModel.attr(
                'popup',
                this.element.find('.c-vc-subnavigation-popup'),
            );
            auth0Init();
            if (this.viewModel.attr('auth0error')) {
                auth0Logout(
                    `${window.globalSettings.vc.auth0.mainUrl}#error-message`,
                );
            }
            const accessToken = localStorageService.getItem('access_token');
            this.viewModel.attr(
                'navigationItems',
                (await getUserInfo(accessToken)) ? loggedItems : notLoggedItems,
            );
            appContext.model.screen.bind(
                'onWindowScroll',
                this.proxy(this.updateScroll),
            );
        },

        updateScroll: function() {
            this.element
                .find('.c-vc-subnavigation-wrapper')
                .attr(
                    'data-scroll-direction',
                    appContext.model.screen.attr('scrollDirection'),
                );
        },

        removed: function() {
            DomEventsManager.unsubscribe(this);
        },
    },
});
